<template>
    <v-layout align-start>
        <v-flex>
            <v-alert type="info" :value="true">{{ message }}</v-alert>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    props: [
        'message'
    ]
}
</script>